import CryptoJS from "crypto-js";
import { getRazorpayCredentials } from "./GetRazorpayCredentials";

export const verifyRazorPay = async (response) => {
  try {
    const { keySecret } = getRazorpayCredentials();
    const key = keySecret;
    const body = `${response.razorpay_order_id}|${response.razorpay_payment_id}`;
    const expectedSignature = CryptoJS.HmacSHA256(body, key).toString(
      CryptoJS.enc.Hex,
    );
    if (expectedSignature === response.razorpay_signature) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    console.error("Error verifying Razorpay signature:", error);
    return { success: false, error: error.message };
  }
};
